const _allLanguages = require('langs')

export let ALL_LANGUAGES = _allLanguages.all()

export const LANGUAGES = {
  en: 'English',
  ru: 'Russian',
  es: 'Espanyol'
}

export const CATEGORIES = {
  All: 'All',
  FoodAndDrink: 'FoodAndDrink',
  Museums: 'Museums',
  HistoricalSites: 'HistoricalSites',
  Gardens: 'Gardens',
  ArtFairsGalleries: 'ArtFairsGalleries',
  Hiking: 'Hiking',
  Shrines: 'Shrines',
  Temples: 'Temples',
  Castles: 'Castles',
  Nature: 'Nature',
  AmusementParks: 'AmusementParks',
  Festivals: 'Festivals',
  Shopping: 'Shopping',
  Culture: 'Culture',
  Kids: 'Kids',
  NightLife: 'NightLife',
  Romance: 'Romance',
  Trendy: 'Trendy',
  Entertainment: 'Entertainment'
}
export const EXPERTISES = {
  one: 'People with Disabilities',
  two: 'Private Groups',
  three: 'Special food',
  four: 'Cycling',
  five: 'Diving',
  six: 'Hiking',
  seven: 'Local operation',
  eight: 'Adventure',
  nine: 'Art',
  ten: 'Architecture'
}
export const CURRENCIES = {
  //EUR: 'EUR',
  USD: 'USD'
  //RUB: 'RUB',
}

export const PLANNING_SERVICES = {
  HotelBooking: 'Hotel Booking',
  CarRental: 'Car Rental',
  FlightBooking: 'Flight Booking',
  TicketsOrdering: 'Tickets Ordering',
  RentHouse: 'Rent House',
  PublicTransport: 'Public Transport',
  LocalSimCard: 'Local Sim Card',
  OnSiteMessageAssistance: 'On Site Message Assistance'
}

export const getGuruNavSteps = t => {
  return [
    {
      title: t('details'),
      route: 'details'
    },
    {
      title: t('description'),
      route: 'description'
    },
    {
      title: t('location'),
      route: 'location'
    },
    {
      title: t('photos'),
      route: 'photos'
    },
    {
      title: t('languages'),
      route: 'languages'
    },
    {
      title: t('service_locations'),
      route: 'guru-locations'
    },
    {
      title: t('category'),
      route: 'category'
    },
    {
      title: t('special_expertise'),
      route: 'expertise'
    },
    {
      title: t('service_description'),
      route: 'service-description'
    },
    {
      title: t('tailored_trips'),
      route: 'trips',
      subtitle: 'Plans and Services'
    },
    {
      title: t('additional_services'),
      route: 'services'
    },
    {
      title: t('pay_pal'),
      route: 'pay-pal'
    },
    {
      title: t('upload_example'),
      route: 'example-plan'
    },
    {
      title: 'Finish',
      route: 'finish'
    }
  ]
}

export const getActivitySteps = t => {
  return [
    {
      title: t('title-tags'),
      route: `title-tags`
    },
    {
      title: t('languages'),
      route: `languages`
    },
    {
      title: t('category'),
      route: `category`
    },
    {
      title: t('description'),
      route: `description`
    },
    {
      title: t('add_photos'),
      route: `photos`
    },
    {
      title: t('what-to-do'),
      route: `what-will-do`,
      subtitle: t('more_details')
    },
    {
      title: t('where_will_be'),
      route: `where-will-be`
    },
    {
      title: t('what_you_provide'),
      route: `what-you-provide`
    },
    {
      title: t('need_to_bring'),
      route: `need-to-bring`
    },
    {
      title: t('add_info'),
      route: `add-info`
    },
    {
      title: t('meeting_point'),
      route: `meeting-point`,
      subtitle: t('times_location')
    },
    {
      title: t('length_price'),
      route: `length-price`
    },
    {
      title: t('trip_dates'),
      route: `event-dates`
    },
    {
      title: 'Finish',
      route: 'finish'
    }
  ]
}

export const DEFAULT_PROFILE_PIC_SRC = '/img/default-profile-image.svg'
export const DEFAULT_CURRENCY = 'USD'

export const getSmsBody = tripLink =>
  `Download the trip plan app. The most convenient way to enjoy your trip.

IOS - Apple Store https://itunes.apple.com/ua/app/inmusiccloud/id1086009081?l=ru&mt=8

Adnroid - Play Market https://play.google.com/store/apps/details?id=com.stackwar.app

The free app gives you easy access to your itinerary, communication with your trip guru and an offline view of your trip details.

Web version https://gettrip.guru/my-trips/${tripLink}`

export const getMailBody = (tripLink) =>
  `A beautiful and organized version of the trip, optimized for you. You can view it on your browser and you can download the app.

A. If you would like to view your itinerary in the browser click here (https://gettrip.guru/my-trip/${tripLink}) and view your itinerary in any browser.

B. Download the trip plan app. The most convenient way to enjoy your trip. 

IOS - Apple Store https://itunes.apple.com/ua/app/inmusiccloud/id1086009081?l=ru&mt=8

Adnroid - Play Market https://play.google.com/store/apps/details?id=com.stackwar.app

The free app gives you easy access to your itinerary, communication with your trip guru, an offline view of your trip details, maps, weather and much more.`



// WEBPACK FOOTER //
// src/constants.js